import { Button } from 'antd';
import styled from 'styled-components';


const AddStorageButton = styled(Button)`
  &&& {
    width: 100%;
    border: 1px dashed #9f9f9f;
    border-radius: 20px;
    height: 107px;
    color: #9f9f9f;
    font-size: 20px;
    background: transparent;
    display:flex;
    align-items:center;
    justify-content: center;
  }
`;

 export default AddStorageButton;